export type MfaRouteDecision = "continue" | "enroll" | "challenge";

export function isPrivilegedUser({ isAdmin, isSuperUser }: { isAdmin: boolean; isSuperUser: boolean }): boolean {
    return isAdmin || isSuperUser;
}

/** Supabase hosts where MFA is skipped: local, hosted dev and staging. Production must never be added. */
const MFA_SKIPPED_HOSTS = [
    "localhost",
    "127.0.0.1",
    "0.0.0.0",
    "::1",
    "[::1]",
    "eqetgfkjuevjkwtjojwc.supabase.co",
    "dev.api.patient.watch",
    "kjtnqcogobfpuojunnqd.supabase.co",
    "staging.api.patient.watch",
];

/**
 * MFA is not enforced when the app talks to the local Supabase stack, hosted dev or staging.
 * Production and any unknown host still enforce it.
 */
export function isMfaEnforced(supabaseUrl: string | undefined = import.meta.env.VITE_SUPABASE_URL): boolean {
    if (!supabaseUrl) return true;
    try {
        const { hostname } = new URL(supabaseUrl);
        return !MFA_SKIPPED_HOSTS.includes(hostname);
    } catch {
        return true;
    }
}

export function getMfaRouteDecision({
    isPrivileged,
    currentLevel,
    hasVerifiedTotp,
}: {
    isPrivileged: boolean;
    currentLevel: "aal1" | "aal2" | null;
    nextLevel: "aal1" | "aal2" | null;
    hasVerifiedTotp: boolean;
}): MfaRouteDecision {
    if (!isPrivileged || currentLevel === "aal2") return "continue";
    return hasVerifiedTotp ? "challenge" : "enroll";
}

export function safeMfaReturnTo(returnTo: string | undefined): string {
    if (!returnTo?.startsWith("/") || returnTo.startsWith("/mfa/")) return "/";
    const base = new URL("https://patient-watch.invalid");
    const destination = new URL(returnTo, base);
    return destination.origin === base.origin ? `${destination.pathname}${destination.search}${destination.hash}` : "/";
}
